/*
 * @Descripttion:
 * @version: 0.0.1
 * @Author: gavin chan
 * @Date: 2020-04-28 11:32:19
 * @LastEditors: gavin chan
 * @LastEditTime: 2020-08-28 14:18:33
 * @Notes:
 */

import React from "react";

import { Switch, Route } from "react-router-dom";

import ProductList from "containers/product/productList";
import ProductDetails from "containers/product/productDetails";
import ProductEditor from "containers/product/productEditor";
import MemberList from "containers/member/memberList";
import MemberDetail from "containers/member/memberDetail";
import MemberDemo from "containers/member/memberDemo";
import MemberConfigList from "containers/memberConfig/memberConfigList";
import AftersaleConfigList from "containers/aftersale/aftersaleConfigList";
import AfterSaleList from "containers/aftersale/aftersaleList";
import ExtraList from "containers/extra/extraList";
import CategoryList from "containers/category/categoryList";
import CommentList from "containers/comment/commentList";
import HotelAgentDetail from "containers/hotelAgent/detail";
import CouponList from "containers/coupon/couponList";
import CouponRecordList from "containers/coupon/couponRecordList";
import CouponEdit from "containers/coupon/couponEdit";
import ImageManager from "containers/image/imageManager/imageManager";

const Routes: React.StatelessComponent = () => {
  const routes = [
    {
      path: "/workbench/products",
      component: ProductList,
      children: [],
    },
    {
      path: "/workbench/product/upload",
      component: ProductEditor,
    },
    {
      path: "/workbench/products/details/:id",
      component: ProductDetails,
    },
    {
      path: "/workbench/products/:id",
      component: ProductEditor,
    },
    {
      path: "/workbench/image/manager",
      component: ImageManager,
    },
    {
      path: "/workbench/members",
      component: MemberList,
    },
    {
      path: "/workbench/members/detail/:id",
      component: MemberDetail,
    },
    {
      path: "/workbench/members/demo/:id",
      component: MemberDemo,
    },
    {
      path: "/workbench/memberConfig",
      component: MemberConfigList,
    },
    {
      path: "/workbench/aftersaleConfig",
      component: AftersaleConfigList,
    },
    {
      path: "/workbench/aftersale",
      component: AfterSaleList,
    },
    {
      path: "/workbench/extra",
      component: ExtraList,
    },
    {
      path: "/workbench/category",
      component: CategoryList,
    },
    {
      path: "/workbench/comments",
      component: CommentList,
    },
    {
      path: "/workbench/hotelAgentDetail",
      component: HotelAgentDetail,
    },
    {
      path: "/workbench/coupons",
      component: CouponList,
    },
    {
      path: "/workbench/coupon/:id",
      component: CouponEdit,
    },
    {
      path: "/workbench/coupon/records/:id",
      component: CouponRecordList,
    },
  ];

  return (
    <Switch>
      {routes.map((route, key) => (
        <Route
          key={key}
          path={route.path}
          exact
          render={(props) => {
            if (route.children) {
              return (
                <div>
                  <Route component={route.component} {...props} />
                  <Switch>
                    {route.children.map((child: any, i: number) => {
                      return (
                        <Route
                          key={i}
                          exact={true}
                          path={child.path}
                          component={child.component}
                        />
                      );
                    })}
                    {/* <Redirect to={route.children[0].path}></Redirect> // 子路由找不到，重定向到第一个子路由 */}
                  </Switch>
                </div>
              );
            } else {
              return <Route component={route.component} {...props}></Route>;
            }
          }}
        />
      ))}
    </Switch>
  );
};

export default Routes;
